import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import { memo } from 'react'

import type { CarouselInformativeItemProps } from '../carousel-informative'
import Background from './Background'
import Content from './Content'

const Slide = ({
  content,
  background,
  classSlide,
  index,
}: CarouselInformativeItemProps) => {
  const { isMobile, sm } = useBreakpoint()

  const isTablet = isMobile
  const isPhone = sm

  const configurationByDevice = () => {
    const targetContent = background.backgroundImages.filter((item) =>
      isPhone
        ? item.device === '(max-width: 28.125em)'
        : isTablet
        ? item.device === '(min-width: 28.125em)'
        : item.device === '(min-width: 48em)'
    )

    const contentConfiguration = {
      alignContentHorizontally:
        targetContent[0]?.alignContentHorizontally ?? '',
      textAlign: targetContent[0]?.textAlign ?? 'center',
    }

    return contentConfiguration
  }

  const contentConfiguration = configurationByDevice()

  return (
    <Background
      index={index}
      contentConfiguration={contentConfiguration}
      background={background}
      classSlide={classSlide}
    >
      <Content
        classSlide={classSlide}
        contentConfiguration={contentConfiguration}
        content={content}
      />
    </Background>
  )
}

export default memo(Slide)
